import { o } from 'odata';
import { odataConf } from './conf';

const url = `${process.env.VUE_APP_APIURL}/odata/`;
const odataEndpoints = require('./odataEndpoints.json');

const actions = {};

odataEndpoints.forEach((odata) => {
  actions[`load.${odata.endPoint}`] = async ({ commit, rootState }) => {
    const data = await o(url, odataConf.getConf(rootState))
      .get(odata.endPoint)
      .query({ $filter: 'IsDeleted eq false' });
    commit(odata.endPoint, data);
  };
  actions[`load.${odata.name}`] = async ({ commit, rootState }, id) => {
    const i = odataConf.parseId(id);
    const data = await o(url, odataConf.getConf(rootState))
      .get(`${odata.endPoint}(${i})`)
      .query();
    commit(odata.name, data);
  };
  actions[`update.${odata.name}`] = async ({ commit, state, rootState }, data) => {
    const i = odataConf.parseId(data.id);
    await o(url, odataConf.getConf(rootState))
      .patch(`${odata.endPoint}(${i})`, data)
      .query();
    const items = state[odata.endPoint].filter(demo => demo.id !== i);
    items.push(data);
    commit(odata.endPoint, items);
    return data;
  };
  actions[`save.${odata.name}`] = async ({ commit, state, rootState }, data) => {
    const result = await o(url, odataConf.getConf(rootState))
      .post(odata.endPoint, data)
      .query();

    const items = state[odata.endPoint];
    items.push(result);
    commit(odata.endPoint, items);
    return data;
  };
  actions[`delete.${odata.name}`] = async ({ commit, state, rootState }, id) => {
    const i = odataConf.parseId(id);
    await o(url, odataConf.getConf(rootState))
      .delete(`${odata.endPoint}(${i})`)
      .query();
    const items = state[odata.endPoint].filter(demo => demo.id !== i);
    commit(odata.endPoint, items);
  };
});
export default actions;
